import { useState } from 'react';
import { useFamilyContext } from '../../contexts/FamilyContext';
import { Origami } from 'lucide-react';

export default function FamilySetup() {
  const { createFamily, loading, error } = useFamilyContext();
  const [familyName, setFamilyName] = useState('');
  const [parentName, setParentName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!familyName.trim() || !parentName.trim()) {
      alert('Please fill in all fields');
      return;
    }

    setSubmitting(true);
    
    try {
      const familyData = {
        name: familyName,
        emoji: '👨‍👩‍👧‍👦',
        parentName: parentName,
        parentAvatar: '👩'
      };

      console.log('Creating family with data:', familyData);
      const result = await createFamily(familyData);
      console.log('Family created successfully!', result);
      
    } catch (error) {
      console.error('Error creating family:', error);
      alert(`Error creating family: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-stone-50">
      <div className="bg-neutral-50/95 backdrop-blur-sm rounded-3xl border border-neutral-50/50 shadow-xl p-12 max-w-lg w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 bg-gradient-to-r from-indigo-500 to-violet-600">
            <Origami className="w-8 h-8 text-neutral-50" />
          </div>
          <h1 className="text-3xl font-semibold text-stone-800">Summer Planning 2025</h1>
          <p className="text-stone-600 mt-2">Let's set up your family profile</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">
              Family Name
            </label>
            <input
              type="text"
              value={familyName}
              onChange={(e) => setFamilyName(e.target.value)}
              className="w-full px-4 py-3 border border-stone-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-neutral-50"
              placeholder="The Smith Family"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">
              Your Name
            </label>
            <input
              type="text"
              value={parentName}
              onChange={(e) => setParentName(e.target.value)}
              className="w-full px-4 py-3 border border-stone-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-neutral-50"
              placeholder="Your name"
              required
            />
          </div>

          <div className="p-4 bg-teal-50 border border-azure-200 rounded-lg">
            <h4 className="font-medium text-teal-900 mb-2">What's Next?</h4>
            <p className="text-sm text-teal-800">
              After creating your family, you can invite your spouse and kids to join by sending them invitation codes. 
              They'll create their own accounts and automatically be added to your family.
            </p>
          </div>

          {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
              {error}
            </div>
          )}
          
          <button
            type="submit"
            disabled={submitting || loading}
            className="w-full py-4 px-6 bg-gradient-to-r from-indigo-500 to-violet-600 text-neutral-50 font-semibold rounded-2xl hover:from-indigo-600 hover:to-violet-700 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            {submitting ? 'Creating Family...' : 'Create Family'}
          </button>
        </form>
      </div>
    </div>
  );
}